import React, { useState } from 'react';
import { Col, Container, Row, Card, CardBody, TabContent, TabPane } from 'reactstrap';
import {
    DashboardPageHeader,
    ResponsiveTabs,
} from '../../Components/Common/DashboardKit';
import CncTab from './components/CncTab';
import ShuklaTab from './components/ShuklaTab';
import WindingTab from './components/WindingTab';
import ProductionTab from './components/ProductionTab';
import QualityTab from './components/QualityTab';

/**
 * Display Boards landing page — live shop-floor status across CNC,
 * Shukla, Winding, Production-Flex, and Quality.
 *
 * Pass 5 UI update (2026):
 *  - Tab strip migrated from inline <Nav>/<NavItem>/<NavLink> to the
 *    shared ResponsiveTabs from the DashboardKit. Same five tabs, same
 *    icons, same active behavior. The "render only the active tab"
 *    lazy-mount pattern is preserved exactly — each TabPane still
 *    guards its child with `{activeTab === tab.id && <TabComponent />}`,
 *    so an inactive tab does not fetch.
 *  - Removed `classnames` import (the shell handles active-state class
 *    application internally now).
 *  - Removed Nav/NavItem/NavLink imports from reactstrap.
 *  - The TABS array, the activeTab state, and the toggle handler are
 *    unchanged.
 */
const TABS = [
    { id: '1', label: 'CNC',               icon: 'ri-settings-3-line',   component: CncTab },
    { id: '2', label: 'Shukla',            icon: 'ri-building-2-line',   component: ShuklaTab },
    { id: '3', label: 'Winding',           icon: 'ri-loop-left-line',    component: WindingTab },
    { id: '4', label: 'Production - Flex', icon: 'ri-hammer-line',       component: ProductionTab },
    { id: '5', label: 'Quality',           icon: 'ri-shield-check-line', component: QualityTab },
];

// Tabs reshaped for ResponsiveTabs (key/label/icon). Memoized at module
// scope since the source list is static — no need to rebuild per render.
const KIT_TABS = TABS.map((t) => ({ key: t.id, label: t.label, icon: t.icon }));

const DisplayBoards = () => {
    document.title = 'Display Board | SSW Technologies Dashboard';

    const [activeTab, setActiveTab] = useState('1');

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-tv-2-line"
                        eyebrow="Shop Floor"
                        title="Display Boards"
                        subtitle="Live status across CNC, Shukla, Winding, Production-Flex, and Quality."
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Display Boards" },
                        ]}
                    />
                    <Row>
                        <Col xxl={12}>
                            <Card>
                                <CardBody>
                                    <ResponsiveTabs
                                        tabs={KIT_TABS}
                                        activeKey={activeTab}
                                        onChange={toggle}
                                        variant="underline"
                                        color="success"
                                        justified
                                    />

                                    <TabContent activeTab={activeTab} className="text-muted">
                                        {TABS.map((tab) => {
                                            const TabComponent = tab.component;
                                            return (
                                                <TabPane tabId={tab.id} key={tab.id}>
                                                    {activeTab === tab.id && <TabComponent />}
                                                </TabPane>
                                            );
                                        })}
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DisplayBoards;
